export const FRESHCHAT_CDN_HOST = '//fw-cdn.com'
export const FRESHCHAT_ACCOUNT_ID = '11458383'
export const FRESHCHAT_APP_ID = '4126454'
export const FRESHCHAT_LOADER_ID = 'koti-freshchat-loader'
